import { defineMessage } from '@redbubble/next/intl';
import hoodieSvg from '../assets/illustrations/hoodie.svg';
import lightweightHoodieSvg from '../assets/illustrations/lightweight-hoodie.svg';
import tshirtSvg from '../assets/illustrations/tshirt.svg';
import { PreTranslatedTableData, StringOrIntl } from '../types';

export const TSHIRT_ILLUSTRATION_PATH: string = tshirtSvg.src;
export const HOODIE_ILLUSTRATION_PATH: string = hoodieSvg.src;
export const LIGHTWEIGHT_HOODIE_ILLUSTRATION_PATH: string =
  lightweightHoodieSvg.src;

const ChooseSizeInstructions: StringOrIntl[] = [
  defineMessage({
    defaultMessage:
      'For the chest, measure 2.5cm / 1in under the left armpit, to 2.5cm / 1in under the right armpit.',
  }),
  defineMessage({
    defaultMessage:
      'For the length, measure from the top of the shoulder next to the collar straight to the bottom of the shirt.',
  }),
  defineMessage({
    defaultMessage:
      'Match this chest and length information to the size guide to find your ideal size.',
  }),
];

export const howToChooseSizeTshirtInstructions: StringOrIntl[] = [
  defineMessage({
    defaultMessage: 'Grab your favorite t-shirt and lay it flat.',
  }),
  ...ChooseSizeInstructions,
];

export const howToChooseSizeHoodieInstructions: StringOrIntl[] = [
  defineMessage({
    defaultMessage: 'Grab your favorite hoodie and lay it flat.',
  }),
  ...ChooseSizeInstructions,
];

export const internationalConversions: PreTranslatedTableData = {
  columns: [
    {
      dataIndex: 'size',
      title: defineMessage({
        defaultMessage: 'Size',
      }),
      align: 'left',
    },
    {
      dataIndex: 'S',
      title: 'S',
      align: 'center',
    },
    {
      dataIndex: 'M',
      title: 'M',
      align: 'center',
    },
    {
      dataIndex: 'L',
      title: 'L',
      align: 'center',
    },
    {
      dataIndex: 'XL',
      title: 'XL',
      align: 'center',
    },
    {
      dataIndex: '2XL',
      title: '2XL',
      align: 'center',
    },
    {
      dataIndex: '3XL',
      title: '3XL',
      align: 'center',
    },
  ],
  rows: [
    {
      size: defineMessage({
        defaultMessage: 'US',
      }),
      S: '2-4',
      M: '4-6',
      L: '6-8',
      XL: '8-10',
      '2XL': '10-12',
      '3XL': '12-14',
    },
    {
      size: defineMessage({
        defaultMessage: 'AU/UK',
      }),
      S: '6-8',
      M: '8-10',
      L: '10-12',
      XL: '12-14',
      '2XL': '14-16',
      '3XL': '16-18',
    },
    {
      size: defineMessage({
        defaultMessage: 'EU',
      }),
      S: '34-36',
      M: '36-38',
      L: '38-40',
      XL: '40-42',
      '2XL': '42-44',
      '3XL': '44-46',
    },
  ],
};

export const extendedInternationalConversions: PreTranslatedTableData = {
  columns: [
    {
      dataIndex: 'size',
      title: defineMessage({
        defaultMessage: 'Size',
      }),
      align: 'left',
    },
    {
      dataIndex: 'S',
      title: 'S',
      align: 'center',
    },
    {
      dataIndex: 'M',
      title: 'M',
      align: 'center',
    },
    {
      dataIndex: 'L',
      title: 'L',
      align: 'center',
    },
    {
      dataIndex: 'XL',
      title: 'XL',
      align: 'center',
    },
    {
      dataIndex: '2XL',
      title: '2XL',
      align: 'center',
    },
    {
      dataIndex: '3XL',
      title: '3XL',
      align: 'center',
    },
    {
      dataIndex: '4XL',
      title: '4XL',
      align: 'center',
    },
    {
      dataIndex: '5XL',
      title: '5XL',
      align: 'center',
    },
  ],
  rows: [
    {
      size: defineMessage({
        defaultMessage: 'US',
      }),
      S: '2-4',
      M: '4-6',
      L: '6-8',
      XL: '8-10',
      '2XL': '10-12',
      '3XL': '12-14',
      '4XL': '14-16',
      '5XL': '16-18',
    },
    {
      size: defineMessage({
        defaultMessage: 'AU/UK',
      }),
      S: '6-8',
      M: '8-10',
      L: '10-12',
      XL: '12-14',
      '2XL': '14-16',
      '3XL': '16-18',
      '4XL': '18-20',
      '5XL': '20-22',
    },
    {
      size: defineMessage({
        defaultMessage: 'EU',
      }),
      S: '34-36',
      M: '36-38',
      L: '38-40',
      XL: '40-42',
      '2XL': '42-44',
      '3XL': '44-46',
      '4XL': '46-48',
      '5XL': '48-50',
    },
  ],
};
